export default function () {
    const self = this

    self.loadEvents()
}
